module.exports = __webpack_public_path__ + "img/viber.6589a4d5.svg";